import { IMAGES } from "@/data/content";

export const Logo = ({ light = false }) => (
    <span className="flex items-center gap-2.5" data-testid="brand-logo">
        <img
            src={IMAGES.logo}
            alt="Hindi Ganga Online Classes logo"
            className="h-14 w-14 rounded-full border border-border bg-white object-cover warm-shadow"
        />
        <span className="leading-tight">
            <span className={`block font-serif text-2xl font-bold tracking-tight ${light ? "text-cream" : "text-ink"}`}>
                Hindi Ganga
            </span>
            <span className={`block text-[10px] font-medium uppercase tracking-[0.24em] ${light ? "text-cream/70" : "text-teal"}`}>
                Online Classes
            </span>
        </span>
    </span>
);
